import { render, staticRenderFns } from "./StatsSection.vue?vue&type=template&id=36efa4b0&scoped=true"
import script from "./StatsSection.vue?vue&type=script&lang=js"
export * from "./StatsSection.vue?vue&type=script&lang=js"
import style0 from "./StatsSection.vue?vue&type=style&index=0&id=36efa4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36efa4b0",
  null
  
)

export default component.exports